import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [4.40250710144],
    [0.40989414976, 1.48302034194, 26087.9031415742],
    [0.05046294199, 4.4778548954, 52175.8062831484],
    [0.00855346843, 1.16520322351, 78263.70942472259],
    [0.00165590362, 4.11969163181, 104351.61256629678],
    [0.00034561897, 0.77930765817, 130439.51570787099],
    [0.00007583476, 3.7134840051, 156527.41884944518],
    [0.0000355974, 1.51202669419, 1109.3785520934],
    [0.00001803463, 4.1033317841, 5661.3320491522],
    [0.00001726012, 0.35832239908, 182615.32199101939],
    [0.00001589923, 2.99510417815, 25028.521211385],
    [0.00001364682, 4.59918318745, 27197.2816936676],
    [0.00001017332, 0.8803143904, 31749.2351907264],
    [0.00000714182, 1.54144865265, 24978.5245894808],
    [0.00000643759, 5.30266110787, 21535.9496445154],
    [0.00000451137, 6.04989275289, 51116.4243529592],
    [0.000004042, 3.28228847025, 208703.22513259358],
    [0.00000352441, 5.24156297101, 20426.571092422],
    [0.00000345212, 2.79211901539, 15874.6175953632],
    [0.00000343313, 5.76531885335, 955.5997416086],
    [0.00000339214, 5.86327765, 25558.2121764796],
    [0.00000325335, 1.3367433478, 53285.1848352418],
    [0.00000272947, 2.49451163975, 529.6909650946],
    [0.00000264336, 3.91705094013, 57837.1383323006],
    [0.00000259587, 0.98732428184, 4551.9534970588],
    [0.00000238793, 0.11343953378, 1059.3819301892],
    [0.0000023483, 0.266721189, 11322.6640983044],
    [0.00000216645, 0.65987207348, 13521.7514415914],
    [0.00000208995, 2.09178234008, 47623.8527860896],
    [0.00000183359, 2.62878670784, 27043.5028831828],
    [0.00000181629, 2.43413502466, 25661.3049506982],
    [0.00000175965, 4.53636829858, 51066.427731055],
    [0.00000172643, 2.45200164173, 24498.8302462904],
    [0.00000142316, 3.36003948842, 37410.5672398786],
    [0.00000137942, 0.29098447849, 10213.285546211],
    [0.00000125219, 3.72079804425, 39609.6545831656],
    [0.00000118233, 2.78149786369, 77204.32749453338],
    [0.00000106422, 4.20572116254, 19804.8272915828],
    [0.0000009686, 6.2039820274, 234791.12827416777],
    [0.00000089987, 5.85243631094, 41962.5207369374],
    [0.00000088329, 5.41338795963, 26617.5941066688],
    [0.00000086819, 2.64219349385, 51646.11531805379],
    [0.00000086723, 1.9595304265, 46514.4742339962],
    [0.00000084971, 4.33100364958, 79373.08797681599],
    [0.00000069729, 3.57201709671, 25132.3033999656],
    [0.00000069247, 4.19446437496, 19.66976089979],
    [0.00000068493, 0.63424819267, 83925.04147387479],
];

const VSOP87_L1: Vsop87Element = [
    [26088.14706222746],
    [0.01126007832, 6.21703970996, 26087.9031415742],
    [0.00303471395, 3.05565472363, 52175.8062831484],
    [0.00080538452, 6.10454743366, 78263.70942472259],
    [0.00021245035, 2.83531934452, 104351.61256629678],
];

const VSOP87_L2: Vsop87Element = [
    [0.00053049845],
    [0.00016903658, 4.69072300649, 26087.9031415742],
    [0.00007396711, 1.34735624669, 52175.8062831484],
    [0.00003018297, 4.45643539705, 78263.70942472259],
    [0.00001107419, 1.26226537554, 104351.61256629678],
    [0.00000378173, 4.319980559, 130439.51570787099],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000188077, 0.03466830117, 52175.8062831484],
    [0.00000142152, 3.125054526, 26087.9031415742],
];

const VSOP87_L4: Vsop87Element = [[0.00000003247, 2.02848007619, 26087.9031415742]];

const VSOP87_L5: Vsop87Element = [];

const VSOP87_B0: Vsop87Element = [
    [0.11737528962, 1.98357498767, 26087.9031415742],
    [0.02388076996, 5.03738959685, 52175.8062831484],
    [0.0054325181, 1.79644363963, 78263.70942472259],
    [0.0012977877, 4.83232503961, 104351.61256629678],
    [0.00031866927, 1.58088495667, 130439.51570787099],
    [0.00007963301, 4.60972126348, 156527.41884944518],
    [0.00002014189, 1.35324164694, 182615.32199101939],
    [0.00000513953, 4.37835409309, 208703.22513259358],
    [0.00000208584, 2.02020294153, 24978.5245894808],
    [0.00000207674, 4.91772564073, 27197.2816936676],
];

const VSOP87_B1: Vsop87Element = [
    [0.00429151362, 3.50169780393, 26087.9031415742],
    [0.00022675295, 0.0151536688, 52175.8062831484],
    [0.00010894981, 0.48540174006, 78263.70942472259],
    [0.00006353462, 3.42943919982, 104351.61256629678],
    [0.00002495743, 0.16051210665, 130439.51570787099],
    [0.00000859585, 3.18452433647, 156527.41884944518],
];

const VSOP87_B2: Vsop87Element = [
    [0.00011830934, 4.79065585784, 26087.9031415742],
    [0.00001913516],
    [0.00001044801, 1.21216540536, 52175.8062831484],
    [0.00000266213, 4.43418336532, 78263.70942472259],
];

const VSOP87_B3: Vsop87Element = [[0.00000235423, 0.35387524604, 26087.9031415742]];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [0.39528271652],
    [0.07834131817, 6.19233722599, 26087.9031415742],
    [0.00795525557, 2.95989690096, 52175.8062831484],
    [0.00121281763, 6.01064153805, 78263.70942472259],
    [0.00021921969, 2.77820093975, 104351.61256629678],
    [0.00004354065, 5.82894543257, 130439.51570787099],
    [0.00000918228, 2.59650562598, 156527.41884944518],
    [0.00000289955, 1.42441936951, 25028.521211385],
    [0.00000260033, 3.02817753482, 27197.2816936676],
    [0.00000201855, 5.6472504035, 182615.32199101939],
    [0.00000201499, 5.59227724202, 31749.2351907264],
    [0.0000014198, 6.25264202645, 24978.5245894808],
    [0.00000100144, 3.73435608689, 21535.9496445154],
    [0.00000077561, 3.66972526976, 20426.571092422],
    [0.000000755, 4.47428642962, 51116.4243529592],
    [0.00000066754, 2.52520309182, 5661.3320491522],
    [0.00000063277, 4.29905918105, 25558.2121764796],
    [0.00000062951, 4.76588899933, 1059.3819301892],
    [0.00000048266, 6.06824478778, 53285.1848352418],
    [0.00000045748, 2.41480951648, 208703.22513259358],
    [0.00000044234, 1.21957314874, 15874.6175953632],
    [0.00000040815, 2.35882016415, 57837.1383323006],
    [0.00000037203, 0.5173382147, 47623.8527860896],
    [0.00000035224, 1.05917802674, 27043.5028831828],
    [0.00000033873, 0.86381554651, 25661.3049506982],
    [0.00000030903, 0.88366335532, 24498.8302462904],
];

const VSOP87_R1: Vsop87Element = [
    [0.00217347739, 4.65617158663, 26087.9031415742],
    [0.00044141826, 1.42385543975, 52175.8062831484],
    [0.00010094479, 4.47466326316, 78263.70942472259],
    [0.00002432804, 1.24226083435, 104351.61256629678],
    [0.00001624367],
    [0.00000603996, 4.29303116561, 130439.51570787099],
];

const VSOP87_R2: Vsop87Element = [
    [0.00003117867, 3.08231840296, 26087.9031415742],
    [0.00001245396, 6.15183317423, 52175.8062831484],
    [0.00000424822, 2.9258335296, 78263.70942472259],
    [0.0000013613, 5.97983925842, 104351.61256629678],
];

const VSOP87_R3: Vsop87Element = [
    [0.00000032676, 1.67971635359, 26087.9031415742],
    [0.00000024166, 4.63403168997, 52175.8062831484],
];

const VSOP87_R4: Vsop87Element = [];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
